import useImmutableSWR from 'swr/immutable';
import type {SWRResponse} from 'swr';
import {CACHE_KEY} from './key';

export function useOfflinePageData(): SWRResponse {
	// This hook is only used to return the cached value, returns null otherwise
	return useImmutableSWR(CACHE_KEY, null);
}
